import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

function EditBuyerModal(props) {
  const [b_name, setBname] = useState(props.editData.name);

  const updateBuyerHandler = (e) => {
    let body = {
      id: props.editData.id,
      name: b_name,
    };
    PostApiWithAuthorizationAction("common/edit-new-render-data", body)
      .then((res) => {
        //toast.success(res.message);
        props.addUpdatedData(res.data);
        props.toggle();
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };
  return (
    <Modal isOpen={props.show} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>Update Buyer Details</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label className="form-control-label" for="b_name">
            Buyer Name
          </Label>
          <Input
            id="b_name"
            type="text"
            placeholder="Buyer Name"
            value={b_name}
            onChange={(e) => setBname(e.target.value)}
          />
          <span className="text-danger">
            <small>*required</small>
          </span>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
          id="update-btn"
          color="primary"
          onClick={updateBuyerHandler}
          disabled={b_name.length === 0}
        >
          Update
        </Button>{" "}
        <Button color="secondary" onClick={props.toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default EditBuyerModal;
